/* eslint-disable import/no-unresolved */
import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { handleAuthData } from 'views/Auth/AuthHelper';
import {
    showReportMenuVar, showCrossReportConfigVar, leftNavigationItemsVar, moduleIdVar,
} from 'Apollo/config';
import Loader from 'views/Shared/components/Loader';

const OAuthComponent = () => {
    const history = useHistory();
    const hasRun = useRef(false);

    const navigateToLandingPage = () => {
        showReportMenuVar(false);
        showCrossReportConfigVar(false);
        leftNavigationItemsVar([]);
        moduleIdVar(null);
        history.push('/');
    };

    useEffect(() => {
        // Prevent double execution
        if (hasRun.current) return;
        hasRun.current = true;

        const authenticate = async () => {
            try {
                const response = await handleAuthData();
                if (response) {
                    navigateToLandingPage();
                } else {
                    console.error('OAuthComponent: Auth failed, redirecting to login');
                    history.push('/login');
                }
            } catch (error) {
                console.error('OAuthComponent: Error during auth:', error);
                history.push('/login');
            }
        };

        authenticate();
    }, []);

    return (
        <Loader />
    );
};

export default OAuthComponent;